module.exports = __webpack_public_path__ + "img/search-white.7dc5b4b5.svg";